/** @jsx jsx */
/** @jsxRuntime classic */
import { jsx } from '@emotion/react';
import React from 'react';
import Icon, { IconName } from '../icons/Icon';
import useTheme from '../style/useTheme';
import { noop } from '../utils';

const BaseInputIcon = ({
  icon,
  onClick = noop,
}: {
  icon?: IconName;
  onClick?: () => void;
}): JSX.Element => {
  const { theme, resolveColor } = useTheme();
  if (!icon) return <React.Fragment />;

  return (
    <div
      css={{
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        margin: ' 0 4px',
      }}
      onClick={onClick}
    >
      <Icon
        icon={icon}
        color={resolveColor(theme.components.input['icon-color'])}
      />
    </div>
  );
};

export default BaseInputIcon;
